import { render, staticRenderFns } from "./other-income-edit-form.html?vue&type=template&id=403706e4&scoped=true&"
import script from "./other-income-edit-form.js?vue&type=script&lang=js&"
export * from "./other-income-edit-form.js?vue&type=script&lang=js&"
import style0 from "./OtherIncomeEditForm.vue?vue&type=style&index=0&id=403706e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403706e4",
  null
  
)

component.options.__file = "OtherIncomeEditForm.vue"
export default component.exports